import axios from 'axios';
import { useStorage } from '../hooks/use-storage';

function usePaymentCardAPI() {
  const { userRef, menuIdRef, languageRef } = useStorage();

  function generatePaymentCardFromRemote(orderIds, tip, type, wallet) {
    const url = `/vbeta2/payments/card`;

    return axios({
      url,
      method: 'post',
      data: {
        order_ids: orderIds,
        tip: tip ?? 0,
        type,
        wallet,
      },
      headers: {
        Authorization: `Bearer ${userRef?.current?.token}`,
        'Menu-Id': menuIdRef.current,
        'Accept-Language': languageRef.current?.tag,
      },
      responseType: 'json',
    });
  }

  function cancelPaymentCardFromRemote(id) {
    const url = `/vbeta2/payments/card/${id}/cancel`;

    return axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${userRef?.current?.token}`,
        'Menu-Id': menuIdRef.current,
        'Accept-Language': languageRef.current?.tag,
      },
      responseType: 'json',
      validateStatus: (status) => [200, 404, 422].includes(status),
    });
  }

  function refreshPaymentCardStatusFromRemote(id) {
    const url = `/vbeta2/payments/card/${id}/refresh`;

    return axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${userRef?.current?.token}`,
        'Menu-Id': menuIdRef.current,
        'Accept-Language': languageRef.current?.tag,
      },
      responseType: 'json',
    });
  }

  return {
    generatePaymentCardFromRemote,
    cancelPaymentCardFromRemote,
    refreshPaymentCardStatusFromRemote,
  };
}

export { usePaymentCardAPI };
